/// <amd-module name="Environments/RunsCommon/Indicator" />
import { TaskResult } from "DistributedTask/Client/Contracts/TaskAgent";
import * as Resources from "Environments/RunsCommon/Resources";

import { Statuses, IStatusProps } from "VSSUI/Status";

namespace Status {
    export const Cancelled = "cancelled";
    export const Failed = "failed";
    export const InProgress = "inprogress";
    export const Pending = "pending";
    export const Skipped = "skipped";
    export const Succeeded = "succeeded";
    export const Unknown = "unknown";
    export const Warning = "warning";
}

interface IStatusIndicatorData {
    statusProps: IStatusProps;
    label: string;
}

function getStatusIndicatorData(status: string): IStatusIndicatorData {
    status = status || "";
    status = status.toLowerCase();
    let indicatorData: IStatusIndicatorData = {
        statusProps: Statuses.Queued,
        label: Resources.StatusQueued
    };
    switch (status) {
        case Status.Cancelled:
            indicatorData.statusProps = Statuses.Canceled;
            indicatorData.label = Resources.StatusCanceled;
            break;
        case Status.Failed:
            indicatorData.statusProps = Statuses.Failed;
            indicatorData.label = Resources.StatusFailed;
            break;
        case Status.InProgress:
            indicatorData.statusProps = Statuses.Running;
            indicatorData.label = Resources.StatusRunning;
            break;
        case Status.Pending:
            indicatorData.statusProps = Statuses.Waiting;
            indicatorData.label = Resources.StatusWaiting;
            break;
        case Status.Skipped:
            indicatorData.statusProps = Statuses.Skipped;
            indicatorData.label = Resources.StatusSkipped;
            break;
        case Status.Succeeded:
            indicatorData.statusProps = Statuses.Success;
            indicatorData.label = Resources.StatusSuccess;
            break;
        case Status.Warning:
            indicatorData.statusProps = Statuses.Warning;
            indicatorData.label = Resources.StatusWarning;
            
            break;
    }

    return indicatorData;
}

/**
 * Gets an IStatusIndicatorData suitable for use with the Status component based on job result
 * @param result The job result
 * @returns An IStatusIndicatorData matching the TaskResult
 */
export function getJobStatusIndicatorData(result?: TaskResult): IStatusIndicatorData {
    let statusType = Status.InProgress; // no result means InProgress

    switch (result) {
        case TaskResult.Succeeded:
            statusType = Status.Succeeded;
            break;
        case TaskResult.SucceededWithIssues:
            statusType = Status.Warning;
            break;
        case TaskResult.Failed:
            statusType = Status.Failed;
            break;
        case TaskResult.Canceled:
            statusType = Status.Cancelled;
            break;
        case TaskResult.Skipped:
            statusType = Status.Skipped;
            break;
        case TaskResult.Abandoned:
            statusType = Status.Cancelled;
            break;
    }

    return getStatusIndicatorData(statusType);
}
